<div ngModelGroup="comboBeneficiario-{{data}}" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="20px">
    <combo-pesquisavel #comboBeneficiario 
                       nome="beneficiario-{{data}}" 
                       [itens]="dados" 
                       itemDescricao="descricaoCombo"
                       itemId="id"
                       [showDisplayId]="showDisplayId" 
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Nome do beneficiário"
                       label="Beneficiário"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
